import { useEffect, useState } from "react";
import { Card, Col, Row } from "react-bootstrap";
import { withTranslation } from "react-i18next";
import { START_DATE, DateRangePickerCalendar } from "react-nice-dates";
import { es, pt, enUS } from "date-fns/locale";
import moment from "moment";
import { DOCTOR_GET_SCHEDULE } from "../../../api/Routes";
import Get from "../../../api/Get";

import "../../../styles/doctores/agenda.css";
import SimpleLoad from "../../../loader/SimpleLoad";

function DatePickerDoctor({
  t,
  setFechaAgenda,
  locale,
  startDate,
  setStartDate,
  endDate,
  setEndDate,
  idDoctor,
  auth,
  setShowModalError,
  setErrorServer,
}) {
  const [focus, setFocus] = useState(START_DATE);
  const [month, setMonth] = useState(new Date());
  const [loadingData, setLoadingData] = useState(false);
  const [modificadores, setModificadores] = useState({});

  const handleFocusChange = (newFocus) => setFocus(newFocus || START_DATE);

  const handleChangeMonth = (n) => {
    setMonth(n);
  };

  const modifiersClassNames = {
    avilable: "-blue",
    mixto: "-warning",
    block: "-block",
  };

  const completeTime = (arrCitas) => {
    //return true
    let firstElement = arrCitas[0];
    if (
      arrCitas.length === 1 &&
      moment(firstElement.dateTimeInit, "YYYY-MM-DDTHH:mm:ss").format(
        "HH:mm:ss"
      ) === "00:00:00" &&
      moment(firstElement.dateTimeEnd, "YYYY-MM-DDTHH:mm:ss").format(
        "HH:mm"
      ) === "23:59"
    ) {
      return true;
    } else if (arrCitas.length === 1) {
      return false;
    } else {
      for (let i = 1; i < arrCitas.length; i++) {
        let formatFirst = moment(
          firstElement.dateTimeEnd,
          "YYYY-MM-DDTHH:mm:ss"
        ).format("HH:mm:ss");
        let formatSecond = moment(
          arrCitas[i].dateTimeInit,
          "YYYY-MM-DDTHH:mm:ss"
        ).format("HH:mm:ss");
        if (formatFirst !== formatSecond) {
          return false;
        } else {
          firstElement = arrCitas[i];
        }
      }
      return true;
    }
  };

  const findType = (date, fechasArr, firstDate, endDate) => {
    let fDate = moment(firstDate, "DD-MM-YYYY");
    let eDate = moment(endDate, "DD-MM-YYYY");
    let d = moment(date);

    if (d.isSameOrAfter(fDate) && d.isSameOrBefore(eDate)) {
      let auxDate = moment(date).format("DD-MM-YYYY");
      let fechasCoincidentes = fechasArr.filter(
        (el) =>
          moment(el.dateTimeInit, "YYYY-MM-DDTHH:mm:ss").format(
            "DD-MM-YYYY"
          ) === auxDate
      );

      let disponible = fechasCoincidentes.filter(
        (el) =>
          el.scheduleType.id === "Online" || el.scheduleType.id === "OnDemand"
      );
      let noDisponibles = fechasCoincidentes.filter(
        (el) =>
          el.scheduleType.id === "Blocked" &&
          el.scheduleType.name !== "FUERA_HORARIO"
      );
      let fueraHorario = fechasCoincidentes.filter(
        (el) =>
          el.scheduleType.id === "Blocked" &&
          el.scheduleType.name === "FUERA_HORARIO"
      );

      if (!disponible.length && !noDisponibles.length && !fueraHorario.length) {
        return "avilable";
      } else if (disponible.length > 0 && noDisponibles.length > 0) {
        return "mixto";
      } else if (disponible.length > 0 && noDisponibles.length === 0) {
        return "avilable";
      } else if (disponible.length === 0 && noDisponibles.length > 0) {
        if (completeTime(noDisponibles)) {
          return "block";
        } else {
          return "mixto";
        }
      } else if (fueraHorario.length > 0 && !completeTime(fueraHorario)) {
        return "avilable";
      } else {
        return "out";
      }
    } else {
      return "";
    }
  };

  //controlando lo que vamos a mostrar segun el mes
  useEffect(() => {
    if (idDoctor) {
      let mounted = true;
      setLoadingData(true);
      let firstDate = moment(month).startOf("month").format("DD-MM-YYYY");
      let endDate = moment(month).endOf("month").format("DD-MM-YYYY");
      let url = `${DOCTOR_GET_SCHEDULE}?order=ASC&id=${idDoctor}&dateScheduleInit=${firstDate}&dateScheduleEnd=${endDate}`;
      Get({ url: url, access_token: auth.data.access_token })
        .then((response) => {
          if (mounted) {
            let fechasArr = response.data.data.response;
            console.log(fechasArr);
            setModificadores({
              avilable: (date) =>
                findType(date, fechasArr, firstDate, endDate) === "avilable"
                  ? true
                  : false,
              mixto: (date) =>
                findType(date, fechasArr, firstDate, endDate) === "mixto"
                  ? true
                  : false,
              block: (date) =>
                findType(date, fechasArr, firstDate, endDate) === "block"
                  ? true
                  : false,
            });
            setLoadingData(false);
          }
          return () => (mounted = false);
        })
        .catch((error) => {
          setLoadingData(false);
          setShowModalError(true);
          if (error.response) {
            setErrorServer(error.response);
          }
        });
      return () => (mounted = false);
    }
  }, [month, idDoctor]);

  return (
    <Card className="shadow-1">
      <Card.Body>
        <h6 className="text-muted">Selecciona los días para asignar horario</h6>
        <Row>
          <Col>
            {loadingData && <SimpleLoad />}
            <DateRangePickerCalendar
              startDate={startDate}
              endDate={endDate}
              focus={focus}
              onStartDateChange={setStartDate}
              onEndDateChange={setEndDate}
              onFocusChange={handleFocusChange}
              locale={locale === "en" ? enUS : locale === "es" ? es : pt}
              minimumDate={new Date()}
              month={month}
              onMonthChange={handleChangeMonth}
              modifiers={modificadores}
              modifiersClassNames={modifiersClassNames}
            />
          </Col>
        </Row>
      </Card.Body>
      <Card.Footer>
        <div className="d-flex flex-column flex-md-row justify-content-between">
          <div>
            <span className="indicador-disponible dot-disponible mr-2"></span>
            <span className="font-weight-bold-600 font-size-08rem">
              {t("disponible")}
            </span>
          </div>
          <div>
            <span className="indicador-mixto dot-mixto mr-2"></span>
            <span className="font-weight-bold-600 font-size-08rem">
              {t("mixto")}
            </span>
          </div>
          <div>
            <span className="indicador-no-disponible dot-no-disponible mr-2"></span>
            <span className="font-weight-bold-600 font-size-08rem">
              {t("no_disponible")}
            </span>
          </div>
        </div>
      </Card.Footer>
    </Card>
  );
}

export default withTranslation()(DatePickerDoctor);
